/* eslint-disable import/prefer-default-export */
import { DEFAULT_ACH_PROXY_PREFIX } from './apiUrls';

// Client-only resolution of the ACH dev-proxy prefix (the same-origin path the
// browser calls; see getDefaultAchApiHost + isAchHost). Overridable via
// VITE_ACH_PROXY_PREFIX in .env, else DEFAULT_ACH_PROXY_PREFIX.
//
// This is kept OUT of any module that vite.config.ts imports: Vite bundles the
// config as CJS to load it, where `import.meta` is unavailable (esbuild
// "empty-import-meta" warning). vite.config.ts resolves the SAME override
// independently via loadEnv, so the browser's target path and the proxy route
// always agree.
export const ACH_PROXY_PREFIX = import.meta.env.VITE_ACH_PROXY_PREFIX || DEFAULT_ACH_PROXY_PREFIX;
